// Omertà Studio Theme: Mobilmenü, Produktauswahl (Größe × Ausführung), Galerie, Warenkorb-Zähler.
(function () {
  var burger = document.querySelector('[data-burger]');
  if (burger) burger.addEventListener('click', function () {
    var m = document.getElementById('mobile-menu');
    var open = m.classList.toggle('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  var club = document.querySelector('[data-club-form]');
  if (club) club.addEventListener('submit', function (e) {
    e.preventDefault();
    var ok = club.querySelector('[data-club-ok]'), err = club.querySelector('[data-club-err]'), btn = club.querySelector('button');
    var email = club.querySelector('[name=email]').value.trim(), consent = club.querySelector('[name=einwilligung]').checked;
    ok.hidden = true; err.hidden = true;
    if (!email) { err.textContent = 'Bitte gib deine E-Mail-Adresse ein.'; err.hidden = false; return; }
    if (!consent) { err.textContent = 'Bitte setz das Häkchen zur Einwilligung, sonst dürfen wir dir nicht schreiben.'; err.hidden = false; return; }
    err.textContent = 'Das hat gerade nicht geklappt. Bitte prüf die Adresse und versuch es nochmal.';
    btn.disabled = true;
    fetch(club.action, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ kunde: 'omerta', email: email, einwilligung: true, quelle: 'shop-club', website: club.querySelector('[name=website]').value }) })
      .then(function (r) { if (!r.ok) throw new Error('nl'); return r.json(); })
      .then(function () { ok.hidden = false; club.querySelector('[name=email]').value = ''; })
      .catch(function () { err.hidden = false; })
      .then(function () { btn.disabled = false; });
  });

  // Tracking: Ereignisse in den dataLayer (GA4-E-Commerce-Schema), GTM reicht sie an den Messdienst weiter
  function dl(ev) { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push(ev); }
  function waehrung() { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'; }

  // Warenkorbseite: begin_checkout beim Klick auf „Zur Kasse“
  var cartItems = document.querySelector('[data-cart-items]');
  var checkoutBtn = document.querySelector('button[name="checkout"]');
  var cartForm = cartItems && checkoutBtn && checkoutBtn.form;
  var checkoutGemeldet = false;
  if (cartForm) cartForm.addEventListener('submit', function (e) {
    var btn = e.submitter || document.activeElement;
    if (!btn || btn.name !== 'checkout' || checkoutGemeldet) return;
    e.preventDefault();
    var weiter = false;
    function geh() {
      if (weiter) return; weiter = true; checkoutGemeldet = true; btn.disabled = false;
      try { cartForm.requestSubmit(btn); }
      catch (x) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = ''; cartForm.appendChild(h); cartForm.submit(); }
    }
    try {
      var items = JSON.parse(cartItems.textContent || '[]');
      var total = parseFloat((document.querySelector('[data-cart-total]') || {}).textContent || '0') || 0;
      dl({ event: 'begin_checkout', ecommerce: { currency: waehrung(), value: total, items: items } });
      btn.disabled = true;
      setTimeout(geh, 1000); // GA4 bündelt Hits kurz; die Navigation sonst verwirft sie
    } catch (x) { geh(); }
  });

  var pd = document.querySelector('[data-produkt]');
  if (!pd) return;
  var varianten = JSON.parse(pd.getAttribute('data-produkt'));
  var auflage = Number(pd.getAttribute('data-auflage') || 100);
  var state = { groesse: pd.getAttribute('data-groesse'), ausf: pd.getAttribute('data-ausf') };
  var sizes = pd.querySelectorAll('[data-groesse-btn]');
  var ausfs = pd.querySelectorAll('[data-ausf-btn]');
  var preis = pd.querySelector('[data-preis]');
  var hinweis = pd.querySelector('[data-edition]');
  var idFeld = pd.querySelector('[name="id"]');
  var cta = pd.querySelector('[data-cta]');
  var rahmenPreis = pd.querySelector('[data-rahmen-aufpreis]');
  var sizeLbl = pd.querySelector('[data-groesse-lbl]');

  function finde(g, a) {
    for (var i = 0; i < varianten.length; i++) if (varianten[i].option1 === g && varianten[i].option2 === a) return varianten[i];
    return null;
  }
  function geld(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €';
  }
  function render() {
    var v = finde(state.groesse, state.ausf);
    sizes.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-groesse-btn') === state.groesse); });
    ausfs.forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-ausf-btn') === state.ausf);
      var vv = finde(state.groesse, b.getAttribute('data-ausf-btn'));
      b.disabled = !vv || !vv.available;
    });
    if (sizeLbl) sizeLbl.textContent = state.groesse;
    var ohne = finde(state.groesse, 'Ungerahmt'), mit = finde(state.groesse, 'Gerahmt, schwarz');
    if (rahmenPreis && ohne && mit) rahmenPreis.textContent = '+ ' + geld(mit.price - ohne.price);
    if (!v) { cta.disabled = true; cta.textContent = 'Nicht verfügbar'; return; }
    idFeld.value = v.id;
    preis.textContent = geld(v.price);
    var rest = v.inventory_quantity;
    if (rest <= 0 || !v.available) {
      hinweis.textContent = 'Ausverkauft in dieser Größe'; hinweis.className = 'edhint';
      cta.disabled = true; cta.textContent = 'Ausverkauft';
    } else {
      hinweis.textContent = 'Noch ' + rest + ' von ' + auflage + ' in dieser Größe'; hinweis.className = rest <= 15 ? 'edhint' : 'edhint ok';
      cta.disabled = false; cta.textContent = 'In den Warenkorb';
    }
    if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
  }
  sizes.forEach(function (b) { b.addEventListener('click', function () { state.groesse = b.getAttribute('data-groesse-btn'); render(); }); });
  ausfs.forEach(function (b) { b.addEventListener('click', function () { state.ausf = b.getAttribute('data-ausf-btn'); render(); }); });
  render();

  // view_item mit der Startvariante
  function artikel(v) {
    return { item_id: (v && v.sku) || String(v && v.id), item_name: pd.getAttribute('data-produkt-titel') || document.title, item_variant: v ? (v.option1 + ' / ' + v.option2) : undefined, item_category: pd.getAttribute('data-serie') || undefined, price: v ? v.price / 100 : undefined, quantity: 1 };
  }
  try { var sv = finde(state.groesse, state.ausf); if (sv) dl({ event: 'view_item', ecommerce: { currency: waehrung(), value: sv.price / 100, items: [artikel(sv)] } }); } catch (x) {}

  // Galerie: Werk an der Wand oder Stimmungsbild ohne Rahmen
  var main = pd.querySelector('[data-gal-main]');
  pd.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      pd.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      var src = b.getAttribute('data-src'), plain = b.getAttribute('data-plain') === '1';
      if (plain) { main.className = 'main plain'; main.innerHTML = '<img src="' + src + '" alt="">'; }
      else { main.className = 'main'; main.innerHTML = '<div class="frame"><div class="mat"><img src="' + src + '" alt=""></div></div>'; }
    });
  });

  // In den Warenkorb per Fetch, danach zur Warenkorbseite
  var form = pd.querySelector('form[action*="/cart/add"]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    cta.disabled = true; cta.textContent = 'Wird hinzugefügt …';
    fetch(form.action + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(idFeld.value), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (item) {
        var ziel = form.getAttribute('data-cart-url') || '/cart', weiter = false;
        function geh() { if (!weiter) { weiter = true; location.href = ziel; } }
        try {
          dl({ event: 'add_to_cart', ecommerce: { currency: waehrung(), value: (item.final_price || item.price) / 100, items: [{ item_id: item.sku || String(item.variant_id || item.id), item_name: item.product_title || pd.getAttribute('data-produkt-titel'), item_variant: item.variant_title, item_category: pd.getAttribute('data-serie') || undefined, price: (item.final_price || item.price) / 100, quantity: item.quantity || 1 }] } });
          setTimeout(geh, 1200); // GA4 bündelt Hits kurz; die Navigation sonst verwirft sie
        } catch (x) { geh(); }
      })
      .catch(function () { cta.disabled = false; cta.textContent = 'In den Warenkorb'; alert('Das hat gerade nicht geklappt. Bitte nochmal versuchen.'); });
  });
})();
